import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import FaEye from 'react-icons/lib/fa/eye'
import FaEyeSlash from 'react-icons/lib/fa/eye-slash'

export default class Text extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    fieldType: PropTypes.string,
    passProps: PropTypes.object,
    placeholder: PropTypes.node
  }

  static defaultProps = {
    fieldType: 'text'
  }

  visible(){
    const btn = document.querySelector('.eyePass')
    const btn2 = document.querySelector('.eyeSlashPass')
    const ipt = document.querySelectorAll('input')

    for(let i= 0; ipt.length > i; i++){
      if(ipt[i].type === "password"){       
        if(ipt[i].value){
            if(ipt[i].value.trim().length > 1){
              btn2.classList.add('active');
              if(btn2.getElementsByClassName('.active')){
                btn2.addEventListener("click",function(e){
                  btn2.classList.remove('active')
                  btn.classList.add('active')
                  ipt[i].type = 'text'
                })
                if(btn.getElementsByClassName('.active')){
                  btn.addEventListener("click",function(e){
                    btn.classList.remove('active')
                    btn2.classList.add('active')
                    ipt[i].type = 'password'
                  })
                }
              }
            }else{
              btn2.classList.remove('active');
            }
          }
        }
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <input
          ref="input"
          className={styles.input}
          type={this.props.fieldType}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={event => this.props.onChange(event.target.value)}
          {...this.props.passProps}
        />
        <a className='eyePass icon' onclick={this.visible()}><FaEye/></a>
        <a className='eyeSlashPass icon' onclick={this.visible()}><FaEyeSlash/></a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/Text/index.js